// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#dropdown-menu- .menu-item,
#dropdown-menu-yearly-policy-menu .menu-item,
#dropdown-menu-previous-months .menu-item,
#dropdown-menu-previous-months2 .menu-item,
#dropdown-menu-previous-year .menu-item {
  margin: 2px;
  border: 2px solid #EDEDED;
  width: auto;
  min-width: 180px;
  max-width: min(340px, 90vw);
}

.menu-item-text-,
.menu-item-text-previous-months {
  text-align: center;
  width: auto;
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/shared-component/CRM-Dropdown/style.scss"],"names":[],"mappings":"AAKI;;;;;EACI,WAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;AAAR;;AAIA;;EAEI,kBAAA;EACA,WAAA;EACA,eAAA;AADJ","sourcesContent":["#dropdown-menu-,\r\n#dropdown-menu-yearly-policy-menu,\r\n#dropdown-menu-previous-months,\r\n#dropdown-menu-previous-months2,\r\n#dropdown-menu-previous-year {\r\n    .menu-item{\r\n        margin: 2px;\r\n        border: 2px solid #EDEDED;\r\n        width: auto;\r\n        min-width: 180px;\r\n        max-width: min(340px, 90vw);\r\n    }\r\n}\r\n\r\n.menu-item-text-,\r\n.menu-item-text-previous-months {\r\n    text-align: center;\r\n    width: auto;\r\n    max-width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
